<template>
  <div class="selectRz">
    <Header title="操作日志"></Header>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="time" label="时间"> </el-table-column>
      <el-table-column prop="operatenr" label="操作"> </el-table-column>
      <el-table-column prop="userrealname" label="操作人"> </el-table-column>
      <el-table-column prop="iswfmes" label="审核说明"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.tableData = this.$route.query.list;
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      //   if (row.iswfmes === "审核通过") {
      //     console.log(row);
      //     return "warning-row";
      //   }
      return "";
    }
  }
};
</script>

<style lang="less" scoped>
.selectRz {
  padding: 0 20px;
}
</style>
<style lang="less">
.selectRz {
  .el-table td {
    border-bottom: 1px solid #ebeef5 !important;
  }
  .el-table .warning-row {
    color: #fff;
    background-color: #12ddd6;
  }
  .shzClass {
    color: #7469f8 !important;
  }
  .btgClass {
    color: #f86969 !important;
  }
  .ytgClass {
    color: #12ddd6 !important;
  }
  .dssClass {
    color: #757da3 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/byxxhd/selectRz.vue